// Ports HomeView from Rev9 Site.html. Inline styles + classes preserved.

import { useNavigate } from 'react-router-dom';

import { MarketingLayout } from '../../components/marketing-shell';

export default function Home() {
  const navigate = useNavigate();
  return (
    <MarketingLayout>
      <main className="view">
        {/* Hero */}
        <section className="hero">
          <div className="container">
            <div className="hero-eyebrow">
              <span className="dot" />
              <span className="kicker">PLATE 01 · PROSPECTUS</span>
              <span className="kicker" style={{ marginLeft: 'auto' }}>MIAMI · FLORIDA</span>
            </div>
            <div className="hero-grid">
              <h1 className="display hero-h1">
                <em>Discretionary</em><br />
                digital asset<br />
                management<br />
                for institutional<br />
                capital.
              </h1>
              <aside className="hero-aside">
                <p className="hero-sub">
                  Quantitative strategy. Daily reconciliation. Monthly statements. Separately managed accounts.
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
                  <button className="btn" onClick={() => navigate('/sign-up')}>
                    Get started <span className="btn-arrow">→</span>
                  </button>
                  <button className="btn-link" onClick={() => navigate('/contact')}>
                    Inquire
                  </button>
                  <button className="btn-link" onClick={() => navigate('/sign-in')}>
                    Client portal
                  </button>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* Approach summary */}
        <section className="section">
          <div className="container">
            <div style={{ marginBottom: 56 }}>
              <span className="kicker">02 · APPROACH</span>
            </div>
            <div className="approach-grid">
              <div className="approach-cell">
                <span className="kicker" style={{ color: 'var(--accent)' }}>MANDATE</span>
                <h3>Separately managed accounts. <em>No pooling, ever.</em></h3>
                <p>
                  Each client holds their position in their own name or in a segregated company sub-account.
                  Performance is calculated and reported per account.
                </p>
                <span className="meta">A1 · ACCOUNT STRUCTURE</span>
              </div>
              <div className="approach-cell">
                <span className="kicker" style={{ color: 'var(--accent)' }}>EXECUTION</span>
                <h3>Active discretionary <em>trading.</em></h3>
                <p>
                  Quantitative signals and human oversight, executed under written discretionary authority.
                  Counterparties are vetted under ongoing diligence and disclosed to clients under engagement.
                </p>
                <span className="meta">A2 · ORDER FLOW</span>
              </div>
              <div className="approach-cell">
                <span className="kicker" style={{ color: 'var(--accent)' }}>REPORTING</span>
                <h3>Daily reconciliation. <em>Monthly close. Immutable statements.</em></h3>
                <p>
                  Holdings reconciled daily against venue records. Monthly statements are final records;
                  corrections supersede but never replace the original.
                </p>
                <span className="meta">A3 · TRANSPARENCY</span>
              </div>
            </div>
          </div>
        </section>

        {/* Pull quote */}
        <section className="pull-section">
          <div className="container pull">
            <blockquote>
              <em>Capital management</em> for clients who want the upside of digital assets without
              the operational <em>chaos</em> of running it themselves.
            </blockquote>
            <div className="pull-attr">
              <span>FROM THE DESK</span>
              <span>·</span>
              <span>REV9 CAPITAL</span>
            </div>
          </div>
        </section>

        {/* Stats strip */}
        <section style={{ padding: 'var(--pad-y) 0' }}>
          <div className="container">
            <div className="stats-strip">
              <div className="stat-cell">
                <div className="label">ASSETS UNDER MANAGEMENT</div>
                <div className="num-large"><span className="tbd">$</span><span className="tbd">tbd</span></div>
                <div className="sub">FIGURE PROVIDED ON INQUIRY</div>
              </div>
              <div className="stat-cell">
                <div className="label">YEARS OPERATING</div>
                <div className="num-large num"><span style={{ color: 'var(--accent)', fontStyle: 'italic' }}>5</span></div>
                <div className="sub">FOUNDED 2021</div>
              </div>
              <div className="stat-cell">
                <div className="label">REPORTING CADENCE</div>
                <div className="num-large num" style={{ fontSize: 'clamp(28px, 3vw, 44px)', lineHeight: 1.1 }}>
                  Daily<br /><span style={{ color: 'var(--accent)', fontStyle: 'italic' }}>&amp; monthly</span>
                </div>
                <div className="sub">RECONCILIATION · STATEMENTS</div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </MarketingLayout>
  );
}
